import {
  GRID_CHECKBOX_SELECTION_COL_DEF,
  GridColDef,
  GridColumnHeaderParams,
  GridHeaderCheckbox,
  useGridApiContext,
} from '@mui/x-data-grid-pro';
import type { ChangeEvent } from 'react';

const DISPLAY_CONTENTS = { display: 'contents' };

// MUI X v8 dropped `indeterminateCheckboxAction`; clicking a partly checked
// select-all box now selects every row. The app was built on the v7 default,
// where that click clears the selection.
function DeselectingHeaderCheckbox(props: GridColumnHeaderParams) {
  const apiRef = useGridApiContext();
  const clearWhenIndeterminate = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.dataset['indeterminate'] !== 'true') return;
    event.stopPropagation();
    apiRef.current.publishEvent('headerSelectionCheckboxChange', {
      value: false,
    });
  };
  return (
    <span style={DISPLAY_CONTENTS} onChangeCapture={clearWhenIndeterminate}>
      <GridHeaderCheckbox {...props} />
    </span>
  );
}

export const checkboxSelectionColumn: GridColDef = {
  ...GRID_CHECKBOX_SELECTION_COL_DEF,
  renderHeader: (params) => <DeselectingHeaderCheckbox {...params} />,
};
